<!-- Encart doux aux jetons (revue design P3.1.0.6, P3.1.8.0.3/4) : cloche de l'app dans une
     pastille, texte lisible, petit bouton vert de l'app (plus de pavé sombre en 13 px). -->
<div class="flex flex-col gap-2 rounded-card bg-vw-surface-tint p-3" data-test="action-needed">
  <div class="flex items-start gap-3">
    <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-field bg-vw-surface text-vw-primary" aria-hidden="true">
      <vw-bell-icon class="block h-5 w-5" />
    </span>
    @if (hint) {
      <div class="flex flex-1 flex-col gap-1">
        <p class="text-body font-medium text-vw-ink">{{ message }}</p>
        <p class="text-body-s text-vw-muted">{{ hint }}</p>
      </div>
    } @else {
      <p class="flex-1 self-center text-body-s font-medium text-vw-ink">{{ message }}</p>
    }
  </div>
  <div class="flex items-center gap-2 pl-12">
    <button type="button" (click)="confirmed.emit()"
      class="min-h-target rounded-pill bg-vw-primary px-4 text-body-s font-semibold text-vw-on-color active:bg-vw-primary-pressed">
      {{ confirmLabel }}
    </button>
    <button type="button" (click)="dismissed.emit()"
      class="min-h-target rounded-pill px-3 text-body-s font-semibold text-vw-primary active:bg-vw-surface">
      {{ dismissLabel }}
    </button>
  </div>
</div>
